/** Token API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import {formData} from '@shared/helpers'
import type {TokenNs} from '@shared/types'

const api = createApi('oauth2', {rootKey: 'APP_AUTH_API_URL'})

const CLIENT_ID = 'client-id'
const CLIENT_SECRET = 'meta-story-1234*-'

export const TokenApi = {
  createToken: (
    payload: TokenNs.CreateTokenRequest | TokenNs.RefreshTokenRequest,
     
    _clientInstanceId: string,
  ) => {
    const data = formData({
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      ...payload,
    })
    return api.post<FormData, TokenNs.CreateTokenResponse>('token', data)
  },
}
